// @ts-ignore
const appSetup = window.appSetup || {};
const locale = appSetup.localization?.dictionaryLocale || 'en_US';

const state = () => ({
  items: [],
});

// mutations
const mutations = {
  setItems(currentState, newValue) {
    currentState.items = newValue;
  },
};

// actions
const actions = {
  async fetch({ state: currentState, commit }) {
    if (currentState.items.length) return;

    try {
      const { data } = await this.$api.getSetup(
        this.getters.getApiLink('user.masterclasses', { locale }),
      );
      commit('setItems', data);
      return data;
    } catch (e) {
      throw new Error('Something went wrong' + e);
    }
  },
};
// actions end

const getters = {
  items: (s) => s.items,
  isAvailable: (currentState, currentGetters, rootState) =>
    rootState.data?.masterClass?.menuEntryVisibility || false,
  link: (currentState, currentGetters, rootState, rootGetters) =>
    `${rootState.data?.masterClass?.link}?lang=${rootGetters.language}`,
};

export default {
  namespaced: true,
  mutations,
  state,
  actions,
  getters,
};
